import api from './ApiSauceInstance'

import { RemoteScreenService } from 'Features/RemoteScreen'

export const RemoteScreenApi = new RemoteScreenService(api)
